var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "SHeaderSection",
    { attrs: { title: `${_vm.stemdoer.name} ${_vm.stemdoer.surname}` } },
    [
      _c("template", { slot: "action" }, [
        _c(
          "div",
          {
            staticClass: "d-flex align-center justify-end w-100",
            staticStyle: { "padding-right": "0" },
          },
          [
            _c(
              "div",
              {
                staticClass: "d-flex justify-end",
                attrs: { "data-cy": "stemdoer-share-row" },
              },
              [
                _c("SShareLink", {
                  attrs: {
                    "data-cy": "stemdoer-share-link",
                    type: "stemdoer",
                    id: _vm.stemdoer.id || "",
                    onLinkCopied: _vm.openPdfModal,
                  },
                }),
              ],
              1
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("SPopUp", {
        staticClass: "mt-n12",
        attrs: {
          isOpen: _vm.popUpData.isOpen,
          sText: _vm.popUpData.message,
          isValid: _vm.popUpData.isValid,
        },
        on: { close: () => (_vm.popUpData.isOpen = false) },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex pt-10",
          staticStyle: { "background-color": "white" },
        },
        [
          _c("StemdoerOverviewCard", { attrs: { stemdoer: _vm.stemdoer } }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "w-100 d-flex flex-column ml-8" },
            [
              _c("SBoxStemdoerCompsAndCerts", {
                attrs: {
                  stemdoer: _vm.stemdoer,
                  onAddOrEditCompsClick: _vm.openAddCompsModal,
                },
              }),
              _vm._v(" "),
              _c("SBoxStemdoerExperience", {
                staticClass: "mt-8",
                attrs: {
                  stemdoer: _vm.stemdoer,
                  onAddExperienceClick: _vm.openAddExperienceModal,
                  onEditExperienceClick: _vm.openAddExperienceModal,
                },
              }),
              _vm._v(" "),
              _c("SBoxStemdoerEducation", {
                staticClass: "mt-8",
                attrs: { stemdoer: _vm.stemdoer },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("ExperienceModal", {
        attrs: {
          isOpen: _vm.isAddExperienceModalOpen,
          experience: _vm.experienceSelected,
          onExperienceSave: _vm.saveExperience,
          onExperienceDelete: _vm.deleteExperience,
          onCloseModal: _vm.closeAddExperienceModal,
        },
      }),
      _vm._v(" "),
      _c("CompsModal", {
        attrs: {
          isOpen: _vm.isAddCompsModalOpen,
          comps: _vm.compsSelected || [],
          onCompsSave: _vm.saveComps,
          onCloseModal: _vm.closeAddCompsModal,
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }